import Box from "@mui/material/Box";
import { actions } from "app/containers/WorkOrder/redux/slice";
import { selectQuotationForm } from "app/containers/WorkOrder/redux/selector";
import { QuotationFormValues } from "app/containers/WorkOrder/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  CURTAIN_FLOOR_BASE_OPTIONS,
  FLOOR_TYPE_OPTIONS,
} from "../../../data";
import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { CROSS_BEAMS_OPTIONS } from "../../../types";
import {
  NumberField,
  NumberedSectionTitle,
  SelectField,
} from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";

const QuoteFloor = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const form = useSelector(selectQuotationForm);

  const updateField = (field: keyof QuotationFormValues, value: string) => {
    dispatch(actions.updateQuotationFormField({ field, value }));
  };

  return (
    <>
      <Box className={styles.inputCard}>
        <NumberedSectionTitle
          number={1}
          titleKey={formKey("SECTIONS.BODY_DIMENSIONS")}
        />
        <Box className={styles.grid3}>
          <NumberField
            labelKey={formKey("FIELDS.BODY_LENGTH")}
            value={form.assembledLength}
            onChange={(value) => updateField("assembledLength", value)}
          />
          <NumberField
            labelKey={formKey("FIELDS.BODY_WIDTH")}
            value={form.assembledWidth}
            onChange={(value) => updateField("assembledWidth", value)}
          />
          <NumberField
            labelKey={formKey("FIELDS.BODY_HEIGHT")}
            value={form.assembledHeight}
            onChange={(value) => updateField("assembledHeight", value)}
          />
        </Box>
      </Box>

      <Box className={styles.inputCard}>
        <NumberedSectionTitle
          number={2}
          titleKey={formKey("SECTIONS.FLOOR_AND_BASE")}
        />
        <Box className={styles.floorGrid}>
          <SelectField
            labelKey={formKey("FIELDS.FLOOR_BASE")}
            value={form.floorBase}
            options={CURTAIN_FLOOR_BASE_OPTIONS}
            onChange={(value) => updateField("floorBase", value)}
            compact
          />
          <SelectField
            labelKey={formKey("FIELDS.FLOOR_TYPE")}
            value={form.floorType}
            options={FLOOR_TYPE_OPTIONS}
            onChange={(value) => updateField("floorType", value)}
            grow
          />
          <NumberField
            labelKey={formKey("FIELDS.FLOOR_THICKNESS")}
            value={form.floorThickness}
            onChange={(value) => updateField("floorThickness", value)}
            compact
          />
          <SelectField
            labelKey={formKey("FIELDS.CROSS_BEAMS")}
            value={form.crossBeams}
            options={CROSS_BEAMS_OPTIONS}
            onChange={(value) => updateField("crossBeams", value)}
            grow
          />
        </Box>
      </Box>
    </>
  );
};

export default QuoteFloor;
